import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";


export default class Button extends PIXI.Sprite
{
    private _resPath: IButtonResPath = null;

    private _isPressed: boolean = false;

    private _value: number = null;

    private _pressedFilter: PIXI.Filter = null;


    public set value( value: number ) { this._value = value; }
    public get value(): number { return this._value; }


    public constructor( resPath: IButtonResPath )
    {
        super();

        this._resPath = resPath;

        this.buttonMode = true;
        this.interactive = true;

        this.texture = ServiceLocator.resources[ resPath.on ].texture;
    
        // Listen to events.
        if ( resPath.hover )
        {
            this.on( "pointerover", this.onPointer_Over, this );
        }
        /*if ( resPath.pressed )
        {*/
            this.on( "pointerdown", this.onPointer_Down, this );
            this.on( "pointerup", this.onPointer_Up, this );
            this.on( "pointerupoutside", this.onPointer_Up, this );
        //}
        /*if ( resPath.hover || resPath.pressed )
        {*/
            this.on( "pointerout", this.onPointer_Out, this );
        //}
        this.on( "pointertap", this.onPointer_Tap, this );
    }

    public reset(): void
    {
        this.texture = ServiceLocator.resources[ this._resPath.on ].texture;
        this._isPressed = false;
        if ( this._pressedFilter )
        {
            this._pressedFilter.enabled = false;
        }
    }

        private onPointer_Over(): void
        {
            if ( !this._isPressed )
            {
                this.texture = ServiceLocator.resources[ this._resPath.hover ].texture;
            }
        }

        private onPointer_Out(): void
        {
            if ( !this._isPressed )
            {
                this.texture = ServiceLocator.resources[ this._resPath.on ].texture;
            }
        }

        private onPointer_Down(): void
        {
            if ( this._resPath.pressed )
            {
                this.texture = ServiceLocator.resources[ this._resPath.pressed ].texture;
            }
            else
            {
                if ( !this._pressedFilter )
                {
                    this._pressedFilter = new PIXI.filters.ColorMatrixFilter();
                    ( this._pressedFilter as any ).brightness( 0.6, false );
                    this.filters = [ this._pressedFilter ];
                }
                this._pressedFilter.enabled = true;
            }

            this._isPressed = true;
        }

        private onPointer_Up(): void
        {
            if ( !this._pressedFilter )
            {
                this.texture = ServiceLocator.resources[ this._resPath.on ].texture;
            }
            else
            {
                this._pressedFilter.enabled = false;
            }

            this._isPressed = false;
        }

        private onPointer_Tap(): void
        {
            ServiceLocator.audio.playSfx( "ui_button_click" );
        }

    public setEnabled( isEnabled: boolean ): void
    {
        this.buttonMode = isEnabled;
        this.interactive = isEnabled;

        if ( this._resPath.off )
        {
            this.texture = ServiceLocator.resources[ isEnabled ? this._resPath.on : this._resPath.off ].texture;
        }
        /*else
        {
            this.alpha = isEnabled ? 1 : 0.5;
        }*/

        if ( this._pressedFilter )
        {
            this._pressedFilter.enabled = false;
        }
    }

    public setTextures( resPath: IButtonResPath ): void
    {
        if ( this._pressedFilter )
        {
            this._pressedFilter.destroy();
            this._pressedFilter = null;

            this.filters.splice( 0 );
        }

        this._resPath = resPath;

        if ( this.interactive && this._resPath.off )
        {
            this.texture = ServiceLocator.resources[ this._resPath.off ].texture;
        }
        else
        {
            this.texture = ServiceLocator.resources[ this._resPath.on ].texture;
        }
    }
}

export interface IButtonResPath
{
    on: string;
    pressed?: string;
    hover?: string;
    off?: string;
}